import { faPlus } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import {
  LoadingDots, Pagination, Placeholder, Table,
} from '../../../../../../components';
import * as Styled from './styles';
import { TRACKING_DOMAINS } from './enums';
import { columns } from './contracts';
import { TRACKING_DETAILS } from '../../enums';

type TrackingDomainsTabProps = {
  modalHook: () => void;
  isOpen: boolean;
  hook: any
  downloadButton: (show: boolean) => void
};

const TrackingDomainsTab = ({
  modalHook, isOpen, hook, downloadButton,
}: TrackingDomainsTabProps) => {
  const [_, setOpenState] = useState(false);
  downloadButton(true);

  useEffect(() => {
    setOpenState(isOpen);
  }, [isOpen]);

  return (

    <Styled.WrapperStyled>
      <Styled.TextStyled>
        {TRACKING_DOMAINS.DESCRIPTION}
      </Styled.TextStyled>

      {hook.hookLoading && (
        <LoadingDots />
      )}

      {hook.hookTrackingDomainsData.length > 0 && !hook.hookLoading && (
        <>
          <Table
            columns={columns}
            data={hook.hookTrackingDomainsData}
            isLoading={hook.hookLoading}
            onSort={hook.hookSetSortBy}
            sortColumn={hook.hookSortBy}
          />
          <Pagination
            total={hook.hookTotalPages}
            currentPage={hook.hookCurrentPage}
            onPageChange={hook.hookSetCurrentPage}
          />
        </>
      )}

      {!hook.hookLoading && hook.hookTrackingDomainsData.length === 0 && (
      <Placeholder
        title={TRACKING_DETAILS.NO_DOMAINS}
        subtitle={TRACKING_DETAILS.NO_DOMAINS_DESCRIPTION}
        action={modalHook}
        buttonIcon={faPlus}
        buttonText={TRACKING_DETAILS.ADD_PROFILE}
      />
      )}
    </Styled.WrapperStyled>
  );
};

export default TrackingDomainsTab;
